export default class util {
    
    static formatTime(n:number):string {
        var hour = this.format2(Math.floor(n / 60));
        var minutes = this.format2(n % 60);
        var result = hour+":"+minutes;
        return result;
    }


    static format2(n:number):string {
        var expanded:string ="0"+n;
        return expanded.substring(expanded.length-2);
    }
}


// WEBPACK FOOTER //
// ./node_modules/@dojo/webpack-contrib/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/util.ts